import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, EMPTY, Observable, of, throwError } from 'rxjs';
import { Spinner } from './spinner';
import { StorageService } from './storage.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { Api } from './api';

@Injectable({
  providedIn: 'root',
})

export class InterceptService implements HttpInterceptor {
  private readonly spinner = inject(Spinner);
  private readonly storageService = inject(StorageService);
  private readonly toastr = inject(ToastrService);
  private readonly ngxUiLoaderService = inject(NgxUiLoaderService);
  private readonly router = inject(Router);
  private readonly apiService = inject(Api);


  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // const storageService = inject(StorageService);
    // const userToken = storageService.get('token');
    // if (userToken) {
    //   req = req.clone({
    //     setHeaders: { Authorization: `Bearer ${userToken}` },
    //     withCredentials: true,
    //   });
    // }
    const toastr = inject(ToastrService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);
    const storageService = inject(StorageService);
    const loader = ngxUiLoaderService.getLoader();
    const cloned = req.body instanceof FormData
      ? req
      : req.clone({
        setHeaders: {
          'Content-Type': req.headers.get('Content-Type') ?? 'application/json',
        },
      });

    return next.handle(cloned).pipe(

      catchError((error) => {
        return handleAuthError(
          error,
          this.toastr,
          this.ngxUiLoaderService,
          this.storageService,
          loader,
          this.router,
          this.apiService
        );
      }) as any,

    );
  }
}
function handleAuthError(
  err: any,
  toastr: ToastrService,
  ngxUiLoaderService: NgxUiLoaderService,
  storageService: StorageService,
  loader: any,
  router: Router,
  apiService: Api
): Observable<any> {
  if (!err) {
    return throwError(() => new Error('Unknown error'));
  }
  if (err.status === 401) {
    toastr.error(err.error.detail ?? err.error.message, "", { timeOut: 5000 });
    storageService.clear();
    apiService.postRequest('/user/logout', {}).subscribe({
      next: (response) => {
        router.navigate(['/login']);

      },
      error: () => {
        // Handle error if needed
      },
    });
    return of(() => err);
  }

  if (err.status === 403 && err.error?.detail?.code === 'ORGANIZATION_DEACTIVATED') {
    ngxUiLoaderService.stopAll();
    toastr.error(err.error.detail.message, 'Error!', { timeOut: 5000 });
    const hasSession = !!storageService.get('Login-SID');
    storageService.clear();
    router.navigate(['/login']);
    if (hasSession) {
      apiService.postRequest('/user/logout', {}, false).subscribe({ error: () => {} });
    }
    return EMPTY;
  }

  if (err.status === 403) {
    setTimeout(() => {
      ngxUiLoaderService.stop();
    }, 500);

    toastr.error(err.error.message ?? err.error.detail, 'Error!', {
      timeOut: 5000,
    });

    return of(err.message);
  }

  if (err.status === 500) {
    setTimeout(() => {
      if (loader && loader.loaderId) {
        ngxUiLoaderService.stopLoader(loader.loaderId);
      } else {
        ngxUiLoaderService.stopAll();
      }
    }, 500);
    let msg = err.error.message
      ? err.error.message
      : 'Something went wrong! Please contact system admin.';
    toastr.error(msg, 'Error!', { timeOut: 5000 });

    return throwError(() => err);
  }

  if (err.status == 400) {
    setTimeout(() => {
      ngxUiLoaderService.stopLoader(loader.loaderId);
    }, 200);
    ngxUiLoaderService.stopAll();

    toastr.error(err.error.detail ?? err.error.message, 'Error!', {
      timeOut: 2000,
    });


    return throwError(() => err);
  }

  if ([410, 404, 409, 405].indexOf(err.status) != -1) {
    setTimeout(() => {
      if (loader?.loaderId) {
        ngxUiLoaderService.stopLoader(loader.loaderId);
      } else {
        ngxUiLoaderService.stopAll();
      }
    }, 200);

    toastr.error(err?.error?.detail ?? err?.error?.message ?? err?.error?.Message, 'Error!');
    return throwError(err?.error?.Message ?? err?.error?.message ?? err);
  }
  if (err.status == 0) {
    setTimeout(() => {
      ngxUiLoaderService.stopAll();
    }, 500);

    setTimeout(
      () => ngxUiLoaderService.stopLoader(loader.loaderId),
      500,
    );

    toastr.error('Network Issue Or Some Error Occured', 'Error!', {
      timeOut: 5000,
    });
    return of('Some Error Occured');
  }
  throw err;
}

